import api from './api';

/**
 * @param {string} level_id
 * @param {string} taskType
 * @param {string} taskId
 * @returns {Promise<unknown>} Format is taskType-specific.
 * @see http://dev-dyl-website-docs-f1dd5d50.s3-website.eu-west-2.amazonaws.com/#api-Tasks-getTaskItems
 */
export default async function getTask(level_id, taskType, taskId) {
    const { data } = await api.get(`levels/${level_id}/task_types/${taskType}/tasks/${taskId}/items`);
    return data;
}